import { render, staticRenderFns } from "./direct-form.vue?vue&type=template&id=50a8aacf&scoped=true"
import script from "./direct-form.vue?vue&type=script&lang=js"
export * from "./direct-form.vue?vue&type=script&lang=js"
import style0 from "./direct-form.vue?vue&type=style&index=0&id=50a8aacf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a8aacf",
  null
  
)

export default component.exports